export default "__VITE_ASSET__828688f8__"